import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Alert, Box, Button, CircularProgress, Paper, Stack, Typography } from '@mui/material';

import SampleDataChip from './SampleDataChip';
import { relatedCountLabel } from './accountRelatedModel';

interface Props {
  children: React.ReactNode;
  count: number;
  error?: Error | null;
  icon: React.ReactNode;
  isLoading: boolean;
  isSampleData?: boolean;
  title: string;
  viewAllTo: string;
}

export default function RelatedListCard({
  children,
  count,
  error,
  icon,
  isLoading,
  isSampleData,
  title,
  viewAllTo,
}: Props) {
  return (
    <Paper variant="outlined">
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 3, py: 2 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          {icon}
          <Typography variant="h6" component="h2">
            {isLoading || error ? title : `${title} (${relatedCountLabel(count)})`}
          </Typography>
          {isSampleData && <SampleDataChip />}
        </Stack>
        {!isLoading && !error && count > 0 && (
          <Button component={Link} to={viewAllTo} variant="text" color="primary">
            View All
          </Button>
        )}
      </Stack>

      <Box sx={{ px: 3, pb: 3 }}>
        {isLoading && <CircularProgress size={24} />}
        {!isLoading && error && (
          <Alert severity="error">
            Could not load {title.toLowerCase()}: {error.message}
          </Alert>
        )}
        {!isLoading && !error && count === 0 && (
          <Typography variant="body2" color="text.secondary">
            No {title.toLowerCase()} on this Account.
          </Typography>
        )}
        {!isLoading && !error && count > 0 && children}
      </Box>
    </Paper>
  );
}
